import React, { useState } from "react";
import userStore from "../../../zustand/userStore";
import { createCostSheet } from "../redux/eventOrganiserThunks";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  clearSelectedActivity,
  clearSelectedEvent,
  setIsNewCostSheet,
} from "../redux/eventOrganiserSlice";

export default function CreateCostSheetForm({ selectedActivity }) {
  console.log("selectedActivity", selectedActivity);
  const userData = userStore((state) => state.user);
  const [formData, setFormData] = useState({
    name: "",
    detail: "",
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = {
      // orgId: userData.org.id,
      userId: userData.id,
      title: formData.name,
      detail: formData.detail,
    };
    const resultAction = await dispatch(
      createCostSheet({
        body,
        // activityId: selectedActivity.id,
        activityId: selectedActivity[0]?.id,
      })
    );
    if (createCostSheet.fulfilled.match(resultAction)) {
      dispatch(setIsNewCostSheet(false));
      dispatch(clearSelectedEvent());
      dispatch(clearSelectedActivity());
      navigate("/showallipcosting");
    }
  };

  return (
    <div
      style={{
        marginTop: "10px",
        padding: "16px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        maxWidth: "400px",
        marginLeft: "180px",
      }}
    >
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "12px" }}>
          <label style={{ display: "block", marginBottom: "4px" }}>Name:</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
            required
          />
        </div>

        <div style={{ marginBottom: "12px" }}>
          <label style={{ display: "block", marginBottom: "4px" }}>
            Detail:
          </label>
          <textarea
            name="detail"
            value={formData.detail}
            onChange={handleChange}
            rows={4}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
            required
          ></textarea>
        </div>

        <button
          type="submit"
          style={{
            backgroundColor: "#1976d2",
            color: "#fff",
            border: "none",
            padding: "10px 16px",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Submit
        </button>
      </form>
    </div>
  );
}
